module.exports = __webpack_public_path__ + "static/media/safari.61ae983d.png";